export type MediaReviewStatus = 'shortlisted' | 'rejected';
export type MediaReviewFilter = 'all' | 'unreviewed' | MediaReviewStatus;

export const ROOT_MEDIA_REVIEW_FOLDER = 'root';

export function isReviewableMedia(file: { mimeType: string | null }): boolean {
  return (
    file.mimeType?.startsWith('image/') === true || file.mimeType?.startsWith('video/') === true
  );
}

export function mediaReviewItemKey(userId: string, fileId: string): string {
  return `${userId}:${fileId}`;
}

export function mediaReviewFolderKey(userId: string, folderId: string | null): string {
  return `${userId}:${folderId ?? ROOT_MEDIA_REVIEW_FOLDER}`;
}

export function mediaReviewStatusFor(
  statuses: Record<string, MediaReviewStatus>,
  userId: string,
  fileId: string,
): MediaReviewStatus | null {
  return statuses[mediaReviewItemKey(userId, fileId)] ?? null;
}

export function filterMediaForReview<T extends { id: string }>(
  items: T[],
  filter: MediaReviewFilter,
  statuses: Record<string, MediaReviewStatus>,
  userId: string,
): T[] {
  if (filter === 'all') return items;
  return items.filter((item) => {
    const status = mediaReviewStatusFor(statuses, userId, item.id);
    return filter === 'unreviewed' ? status === null : status === filter;
  });
}

export function summarizeMediaReview(
  fileIds: string[],
  statuses: Record<string, MediaReviewStatus>,
  userId: string,
) {
  let shortlisted = 0;
  let rejected = 0;
  for (const fileId of fileIds) {
    const status = mediaReviewStatusFor(statuses, userId, fileId);
    if (status === 'shortlisted') shortlisted += 1;
    if (status === 'rejected') rejected += 1;
  }
  return { shortlisted, rejected, unreviewed: fileIds.length - shortlisted - rejected };
}
